import { render, staticRenderFns } from "./Active-Inactive-Sensors.vue?vue&type=template&id=3dfbc228&scoped=true"
import script from "./Active-Inactive-Sensors.vue?vue&type=script&lang=js"
export * from "./Active-Inactive-Sensors.vue?vue&type=script&lang=js"
import style0 from "./Active-Inactive-Sensors.vue?vue&type=style&index=0&id=3dfbc228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbc228",
  null
  
)

export default component.exports